module.exports = __webpack_public_path__ + "zvetseni-prsou_23_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_23_after.jpg
// module id = 1317
// module chunks = 0